module.exports = __webpack_public_path__ + "static/img/csv.3d673332.png";